import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppRentalHeader from '../containers/AppRentalHeader'
import { withNamespaces } from "react-i18next"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { fetchAvailability } from '../actions/qrs'
import StepBarRental from '../components/StepBarRental'

class ZoneSelectorRentalView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      isMapFullscreen: false,
      zones: null,
      description: null,
      customerName: null,
      forwardScreen: false,
      machineSleeping: false
    }

    this.toggle = this.toggle.bind(this);
    this.goTo = this.goTo.bind(this);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  toggleMapFullscreen() {
    this.setState({
      isMapFullscreen: !this.state.isMapFullscreen
    })
  }

  goTo(zoneNumber, descriptionZone, e) {
    const { id } = this.props.match.params;
    const { qrMode } = this.props.location.state;

    this.setState(
      {
        forwardScreen: true,
      },
      () => {
        console.log("forwardScreen: ", this.state.forwardScreen);
        history.push('/lockerSelectorRentalView', { zoneSelected: zoneNumber, descriptionZone: descriptionZone, qr: id, customerName: this.state.customerName, qrMode: qrMode });
      }
    );
  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';
    
    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getIconColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.iconsColor || '#01315f';
  }

  componentDidMount() {

    const { id } = this.props.match.params;
    const searchParams = new URLSearchParams(this.props.location.search);
    //const lockerAssigned = searchParams.get('lockerAssigned');

    let autorizeCancelPrebooking = true;

    const navigationEntries = window.performance.getEntriesByType('navigation');
    if ((navigationEntries.length > 0) && (navigationEntries[0].type === 'reload')) {
      console.log("Page was reloaded");
      autorizeCancelPrebooking = false;
    }

    // Get current Spain time
    const now = new Date();
    const spainTime = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Madrid',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false,
    }).formatToParts(now);

    // Extract the hour part
    const hour = parseInt(spainTime.find(part => part.type === 'hour').value, 10);

    // Check if the time is between 22:00 and 01:00
    if ((hour == 23) || (hour == 0)) {
      this.setState({
        machineSleeping: true, // Add a flag for sleeping state
      });
      return;
    }

    this.props.fetchAvailability(id)
      .then((answer) => {

        let answerZones = answer.response.answerZones

        if (answerZones.multipleZones) {
          this.setState({ zones: answerZones.multipleZones });
          this.setState({ description: answerZones.descriptionZones });
        } else if (answerZones.singleZone) {
          this.goTo(answerZones.singleZone, answerZones.descriptionZones[(answerZones.singleZone) - 1], 0)
        }

        this.setState({ customerName: answerZones.customerName });
      })
      .catch((error) => {
        console.error(error);
      });

  }

  renderSleepingMessage() {
    const { t } = this.props;
    const { customerName } = this.state;

    return (
      <div>
        <AppRentalHeader />
        <div className="lockerContainer">
          <br></br>
          <StepBarRental step={1} />
          <br></br>
          <h3 className="lockTitle">
            <span className="text-vw-dark">{t('BIENVENIDO A')}</span>
            <br></br>
            <span className="text-vw-light">{customerName}</span>
          </h3>
          <br></br>
          <div className="sleeping-message lockTitle w-75 m-auto">
            <h3 className="text-warning">{t('Fuera de horario')}</h3>
            <p>{t('Lo sentimos, pero la venta no está disponible entre las 23:00h y la 01:00h, vuelva fuera de este horario.')}</p>
            <img src="/images/sleeping_machine.webp" alt="Sleeping Machine" className="sleeping-image w-75" />
          </div>
        </div>
      </div>
    );
  }

  getMapPicture(type) {
    switch (type) {
      case 0:
        return '/images/maps/mapaportaventura.svg'
      default:
        return '/images/maps/mapaportaventura.svg'
    }
  }

  renderZones() {
    const { t, i18n } = this.props
    const { zones, description, customerName } = this.state;
    const zoneDivs = []

    const buttonStyle = this.getButtonStyle();
    const iconsColor = this.getIconColor();
    const buttonText = this.props.qrData?.headerConfig?.buttonText || '#ffffff';

    if (!zones || !description) {
      return (<div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    } else {
      zones
        .sort((a, b) => a - b)
        .map((zone) => (

          zoneDivs.push(
            <div className="col-xs-12" key={zone}>
              <div className="lockButtonRental" style={buttonStyle} onClick={(e) => this.goTo(zone, description[zone - 1], e)}>
                <div className="row">
                  <div className="col col-4">
                    <img src="/images/PingRental.svg" alt={"Ping " + zone} className="pingImage" style={{ filter: `drop-shadow(0 0 5px ${iconsColor})` }} />
                  </div>
                  <div className="col col-8 zoneDescriptionRental">
                    <h5 style={{ color: buttonText }}>{t('ZONA ') + zone}</h5>
                    <p style={{ color: buttonText }}>{t(description[zone - 1])}</p>
                  </div>
                </div>
              </div>
            </div>
          )
        ));

      return (<div>{zoneDivs}</div>)
    }
  }

  renderZonesPc() {
    const { t, i18n } = this.props
    const { zones, description, customerName } = this.state;
    const zoneDivs = []

    const buttonStyle = this.getButtonStyle();
    const iconsColor = this.getIconColor();
    const buttonText = this.props.qrData?.headerConfig?.buttonText || '#ffffff';

    if (!zones || !description) {
      return (<div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    } else {
      zones
        .sort((a, b) => a - b)
        .map((zone) => (

          zoneDivs.push(
            <div className="col-xs-12" key={zone}>
              <div className="lockButtonRental" style={buttonStyle} onClick={(e) => this.goTo(zone, description[zone - 1], e)}>
                <img src="/images/PingRental.svg" alt={"Ping " + zone} className="pingImage" style={{ filter: `drop-shadow(0 0 5px ${iconsColor})` }} />
                <h5 className="text-white text-center" style={{ color: buttonText }}>{t('ZONA ') + zone}</h5>
                <p className="text-white text-center" style={{ color: buttonText }}>{t(description[zone - 1])}</p>
              </div>
            </div>
          )
        ));

      return (
        <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
          <div className="row justify-content-center rental-zoneSelector" style={{ display: 'flex', flexDirection: 'row', gap: '1rem', padding: '1rem 0', minWidth: 'max-content' }}>
            {zoneDivs}
          </div>
        </div>
      )
    }
  }

  render() {
    const { t, i18n } = this.props
    const { zones, description, customerName, machineSleeping } = this.state;

    if (machineSleeping) {
      return this.renderSleepingMessage();
    }

    return (
      <div className="rentalBackground">
        <AppRentalHeader />
        <div className="lockerContainer smartphone">
          <br></br>
          <h3 className="lockTitle">
            <span className="text-vw-dark">{t('BIENVENIDO A')}</span>
          </h3>
          <h2 className="text-center">
            <span className="text-vw-light">{customerName}</span>
          </h2>
          <h4 className="lockTitle">
            <span className="text-secondary">{t('SELECCIONA LA ZONA DE TAQUILLAS')}</span>
          </h4>

          {this.renderZones()}
          <br></br>
          <StepBarRental step={1} />

          {/* <div className="col-xs-12">
            <Button className="mapButton" onClick={() => this.toggleMapFullscreen()}>VER MAPA DE ZONAS</Button>
          </div> */}

          <div>
            <Modal isOpen={this.state.isMapFullscreen}
              toggle={this.toggleMapFullscreen}>
              <ModalHeader toggle={this.toggleMapFullscreen}>
                MAPA DEL PARQUE
              </ModalHeader>
              <ModalBody>
                <img src={this.getMapPicture(0)} alt="Mapa" className="fullscreenMapImage" />
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={() => this.toggleMapFullscreen()}>
                  Cerrar
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
        <div className="lockerContainer pc">
          <h3 className="mt-4 lockTitle">
            <span className="text-vw-dark">{t('BIENVENIDO A')}</span>
          </h3>
          <h1 className="text-center">
            <span className="text-vw-light">{customerName}</span>
          </h1>
          <h4 className="lockTitle">
            <span className="text-vw-dark">{t('SELECCIONA LA ZONA DE TAQUILLAS')}</span>
          </h4>

          {this.renderZonesPc()}

          <StepBarRental step={1} />

          {/* <div className="col-xs-12">
                <Button className="mapButton" onClick={() => this.toggleMapFullscreen()}>VER MAPA DE ZONAS</Button>
              </div> */}

          <div>
            <Modal isOpen={this.state.isMapFullscreen}
              toggle={this.toggleMapFullscreen}>
              <ModalHeader toggle={this.toggleMapFullscreen}>
                MAPA DEL PARQUE
              </ModalHeader>
              <ModalBody>
                <img src={this.getMapPicture(0)} alt="Mapa" className="fullscreenMapImage" />
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={() => this.toggleMapFullscreen()}>
                  Cerrar
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  availability: state.availability,
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  fetchAvailability: bindActionCreators(fetchAvailability, dispatch)
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ZoneSelectorRentalView));